import { defineQuery } from 'next-sanity'

export const pricePlansFields = `
  _id,
  _type,
  title,
  description,
  lastUpdated,
  priceTabs[]{
    tabTitle,
    pricePlan[]{
      title,
      "priceItem": priceItem[]{
        title,
        price
      }
    }
  }
`

export const PRICE_PLANS_QUERY = defineQuery(/* groq */ `
  *[_type == "price-plans"][0]{
    ${pricePlansFields}
  }
`)
